<h2 mat-dialog-title>Billable Hours - Custom Date Range</h2>
<mat-dialog-content class="dialog-content">
  <div class="date-range-display">
    <div class="date-picker-wrapper">
      <input
        matInput
        [matDatepicker]="startPicker"
        [(ngModel)]="startDate"
        class="hidden-input"
        readonly
      />
      <span
        class="date-range-text date-picker-trigger"
        [style.cursor]="'pointer'"
        (click)="startPicker.open(); $event.stopPropagation()"
      >
        {{ getFormattedDate(startDate) }}
      </span>
      <mat-datepicker #startPicker></mat-datepicker>
    </div>

    <span class="date-separator">—</span>

    <div class="date-picker-wrapper">
      <input
        matInput
        [matDatepicker]="endPicker"
        [(ngModel)]="endDate"
        [min]="startDate"
        class="hidden-input"
        readonly
      />
      <span
        class="date-range-text date-picker-trigger"
        [style.cursor]="'pointer'"
        (click)="endPicker.open(); $event.stopPropagation()"
      >
        {{ getFormattedDate(endDate) }}
      </span>
      <mat-datepicker #endPicker></mat-datepicker>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button class="cancel-button" (click)="onCancel()">
    Cancel
  </button>
  <button mat-flat-button class="apply-button" (click)="onApply()">
    Apply
  </button>
</mat-dialog-actions>
